(function () {
  if (window.__merchmarketMobileMenuGuard) return;
  window.__merchmarketMobileMenuGuard = true;

  var style = document.createElement('style');
  style.id = 'merchmarket-mobile-menu-guard-style';
  style.textContent = '@media screen and (max-width:699px){' +
    '#header-sidebar-menu{' +
      '--drawer-content-max-height:calc(100dvh - max(16px, env(safe-area-inset-top)) - max(16px, env(safe-area-inset-bottom)))!important;' +
      'position:fixed!important;' +
      'top:max(8px,env(safe-area-inset-top))!important;' +
      'bottom:max(8px,env(safe-area-inset-bottom))!important;' +
      'height:auto!important;' +
      'max-height:none!important;' +
      'overflow:visible!important;' +
      'z-index:2147483647!important;' +
    '}' +
    '#header-sidebar-menu > [is="close-button"]{' +
      'display:flex!important;' +
      'position:absolute!important;' +
      'top:16px!important;' +
      'right:16px!important;' +
      'z-index:2147483647!important;' +
      'align-items:center!important;' +
      'justify-content:center!important;' +
      'color:#170022!important;' +
    '}' +
    '#header-sidebar-menu > [is="close-button"] svg{' +
      'display:none!important;' +
    '}' +
    '#header-sidebar-menu > [is="close-button"]::before{' +
      'content:"×"!important;' +
      'display:block!important;' +
      'position:absolute!important;' +
      'left:50%!important;' +
      'top:50%!important;' +
      'font-family:Arial,sans-serif!important;' +
      'font-size:32px!important;' +
      'font-weight:400!important;' +
      'line-height:1!important;' +
      'color:currentColor!important;' +
      'transform:translate(-50%,-50%)!important;' +
    '}' +
    '#header-sidebar-menu > [is="close-button"]::after{' +
      'content:none!important;' +
      'display:none!important;' +
    '}' +
    '#header-sidebar-menu .panel-list__wrapper > .panel > .panel__wrapper > .panel__scroller{' +
      'padding-top:72px!important;' +
    '}' +
    '#header-sidebar-menu .panel__wrapper li.h3,' +
    '#header-sidebar-menu .panel__wrapper li.h4,' +
    '#header-sidebar-menu .panel__wrapper li.h5,' +
    '#header-sidebar-menu .panel__wrapper li.h6,' +
    '#header-sidebar-menu .panel__wrapper a,' +
    '#header-sidebar-menu .panel__wrapper button{' +
      'text-transform:none!important;' +
    '}' +
    '#header-sidebar-menu navigation-panel,' +
    '#header-sidebar-menu .navigation-panel{' +
      'max-height:100%!important;' +
      'overflow-y:auto!important;' +
      '-webkit-overflow-scrolling:touch;' +
      'overscroll-behavior:contain;' +
    '}' +
  '}' +
  '@media screen and (max-width:1250px) and (orientation:landscape){' +
    'html:has(body.mm-mobile-menu-open),body.mm-mobile-menu-open{' +
      'overflow:hidden!important;' +
      'overscroll-behavior:none!important;' +
    '}' +
    '#header-sidebar-menu{' +
      '--drawer-content-max-height:calc(100dvh - 16px)!important;' +
      'position:fixed!important;' +
      'top:8px!important;' +
      'bottom:8px!important;' +
      'height:auto!important;' +
      'max-height:none!important;' +
      'overflow:visible!important;' +
      'z-index:2147483647!important;' +
    '}' +
    '#header-sidebar-menu > [is="close-button"]{' +
      'display:flex!important;' +
      'position:absolute!important;' +
      'top:8px!important;' +
      'right:8px!important;' +
      'left:auto!important;' +
      'width:44px!important;' +
      'height:44px!important;' +
      'min-width:44px!important;' +
      'min-height:44px!important;' +
      'padding:0!important;' +
      'z-index:2147483647!important;' +
      'align-items:center!important;' +
      'justify-content:center!important;' +
      'color:#170022!important;' +
    '}' +
    '#header-sidebar-menu > [is="close-button"] svg{' +
      'display:none!important;' +
    '}' +
    '#header-sidebar-menu > [is="close-button"]::before{' +
      'content:"×"!important;' +
      'display:block!important;' +
      'position:absolute!important;' +
      'left:50%!important;' +
      'top:50%!important;' +
      'font-family:Arial,sans-serif!important;' +
      'font-size:22px!important;' +
      'font-weight:400!important;' +
      'line-height:1!important;' +
      'color:currentColor!important;' +
      'transform:translate(-50%,-50%)!important;' +
    '}' +
    '#header-sidebar-menu > [is="close-button"]::after{' +
      'content:none!important;' +
      'display:none!important;' +
    '}' +
    '#header-sidebar-menu .panel__wrapper *{' +
      'text-transform:none!important;' +
    '}' +
    '#header-sidebar-menu .panel-list__wrapper > .panel > .panel__wrapper > .panel__scroller{' +
      'padding-top:44px!important;' +
      'padding-bottom:24px!important;' +
      'max-height:calc(100dvh - 16px)!important;' +
      'overflow-y:auto!important;' +
      '-webkit-overflow-scrolling:touch;' +
      'overscroll-behavior:contain;' +
    '}' +
    '#header-sidebar-menu navigation-panel,' +
    '#header-sidebar-menu .navigation-panel{' +
      'max-height:none!important;' +
      'overflow:visible!important;' +
      'overscroll-behavior:auto;' +
    '}' +
  '}';
  document.head.appendChild(style);

  var menu = document.getElementById('header-sidebar-menu');
  if (!menu) return;

  function toSentenceCase(raw) {
    if (!raw) return raw;
    if (raw === 'Q&A' || raw === 'R&B' || raw === 'NZD $' || raw === 'X') return raw;

    var sentence = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
    return sentence
      .replace(/\btiktok\b/g, 'TikTok')
      .replace(/\byoutube\b/g, 'YouTube')
      .replace(/\byoutubers\b/g, 'YouTubers');
  }

  function sentenceCaseMenuLinks() {
    var root = menu.querySelector('.panel-list__wrapper') || menu;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;

    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || /^(SCRIPT|STYLE|SVG)$/i.test(parent.tagName)) continue;

      var value = node.nodeValue || '';
      var leading = value.match(/^\s*/)[0];
      var trailing = value.match(/\s*$/)[0];
      var raw = value.trim();
      if (!raw) continue;

      var sentence = toSentenceCase(raw);
      var nextValue = leading + sentence + trailing;
      if (value !== nextValue) node.nodeValue = nextValue;
    }
  }

  sentenceCaseMenuLinks();

  var perks = null;
  var perksPreviousZIndex = '';

  function collectRoots(root, out) {
    out.push(root);
    if (!root.querySelectorAll) return;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) collectRoots(all[i].shadowRoot, out);
    }
  }

  function fixedAncestor(el) {
    var node = el;
    for (var i = 0; i < 8 && node; i++) {
      try {
        var position = getComputedStyle(node).position;
        if (position === 'fixed' || position === 'sticky') return node;
      } catch (e) {}
      node = node.parentElement;
    }
    return el;
  }

  function findPerks() {
    var roots = [];
    collectRoots(document, roots);

    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (!root.querySelectorAll) continue;
      var nodes = root.querySelectorAll('button,a,[role="button"],iframe');

      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.closest && el.closest('.miko-storefront')) continue;

        var text = el.textContent || '';
        var aria = el.getAttribute && el.getAttribute('aria-label') || '';
        var title = el.getAttribute && el.getAttribute('title') || '';
        var src = el.getAttribute && el.getAttribute('src') || '';
        var label = (text + ' ' + aria + ' ' + title + ' ' + src).replace(/\s+/g, ' ').trim().toLowerCase();

        if (label === 'perks' || label.indexOf('smile.io') !== -1 || label.indexOf('smile-ui') !== -1 || label.indexOf('smile-io') !== -1) {
          return fixedAncestor(el);
        }
      }
    }

    if (document.elementsFromPoint) {
      var points = [
        [window.innerWidth - 55, window.innerHeight - 95],
        [window.innerWidth - 55, window.innerHeight - 155]
      ];

      for (var p = 0; p < points.length; p++) {
        var stack = document.elementsFromPoint(points[p][0], points[p][1]);
        for (var s = 0; s < stack.length; s++) {
          var candidate = stack[s];
          if (candidate === menu || menu.contains(candidate)) continue;
          if (candidate.closest && candidate.closest('.miko-storefront')) continue;

          var fixed = fixedAncestor(candidate);
          try {
            var rect = fixed.getBoundingClientRect();
            if (rect.width <= 240 && rect.height <= 180 && rect.right >= window.innerWidth - 180 && rect.bottom >= window.innerHeight - 260) {
              return fixed;
            }
          } catch (e) {}
        }
      }
    }

    return null;
  }

  function setOpen(open) {
    document.body.classList.toggle('mm-mobile-menu-open', !!open);

    if (!perks || !document.documentElement.contains(perks)) perks = findPerks();
    if (perks) {
      if (open) {
        perksPreviousZIndex = perks.style.zIndex || '';
        perks.style.setProperty('z-index', '1', 'important');
      } else {
        if (perksPreviousZIndex) perks.style.zIndex = perksPreviousZIndex;
        else perks.style.removeProperty('z-index');
      }
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[aria-controls="header-sidebar-menu"]');
    if (opener) {
      setTimeout(function () {
        sentenceCaseMenuLinks();
        setOpen(true);
      }, 0);
      return;
    }

    if (menu.contains(event.target)) {
      setTimeout(sentenceCaseMenuLinks, 0);
      setTimeout(sentenceCaseMenuLinks, 80);
    }

    var closer = event.target.closest && event.target.closest('#header-sidebar-menu [is="close-button"], #header-sidebar-menu a');
    if (closer) setTimeout(function () { setOpen(false); }, 0);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });

  var observer = new MutationObserver(function (mutations) {
    var needsCaseRefresh = false;

    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].type === 'childList') needsCaseRefresh = true;
    }

    if (needsCaseRefresh) setTimeout(sentenceCaseMenuLinks, 0);
    if (menu.hasAttribute('open') || menu.getAttribute('aria-hidden') === 'false') setOpen(true);
    if (menu.hidden || menu.getAttribute('aria-hidden') === 'true') setOpen(false);
  });
  observer.observe(menu, {
    attributes: true,
    attributeFilter: ['open', 'hidden', 'aria-hidden', 'class', 'style'],
    childList: true,
    subtree: true
  });
})();